import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {config} from '@app/modules/config';
import Lottie from '@app/components/Lottie';

export const SongcatcherPower: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'songcatcherlandingpage_title_thepowerofmusicrecognition_standalone-web',
							{
								ns: 'songcatcher',
							},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'songcatcherlandingpage_text_thepowerofmusicrecognition_standalone-web',
							{
								ns: 'songcatcher',
							},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Lottie
					src={`${config.get('appAssetsUrl') || '/explore'}/images/lotties/songcatcher-power.lottie`}
					height={400}
					width={400}
				/>
			}
		/>
	);
};
